<template>
  <v-container class="ma-0 pa-0" width="100%" height="100%">
    <!-- action card-->
    <v-container class="ma-0 pa-0 d-flex justify-space-between" width="100%">
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-btn
          :loading="loader"
          @click="saveAndReturn()"
          class="ma-0 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("Save and Return to list") }}
          <v-icon small color="gary">mdi-file-document</v-icon>
        </v-btn>
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-btn outlined @click="clearForm()" class="ms-2 pa-0" color="pink" height="32">
          <p class="font-weight-thin mb-0 px-4">
            {{ $t("clearForm") }}
          </p>
          <v-icon small color="gary"> mdi-refresh </v-icon>
        </v-btn>
      </v-container>
    </v-container>
  </v-container>
</template>
<script>
export default {
  name: "ActionSection",
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    loader: {
      deep: true,
      handler(val) {
        // if (val) {
          this.loading = val;
        // }
      },
    },
  },
  components: {},
  data: () => ({
    loading: false,
  }),
  mounted() {},
  methods: {
    goToWorkshop() {
      this.$router.push("/payroll/workshop/create");
    },
    saveAndNew() {
      this.$emit("click-save-and-new");
    },
    saveAndReturn() {
      this.$emit("click-save-and-return");
    },
    clearForm() {
      this.$emit("clear-form");
    },
    back() {
      this.$router.push("/payroll/workshop");
    },
    openFilters() {
      this.$emit("open-filters");
    },
    getItems() {
      this.$emit("get-items");
    },
  },
};
</script>
<style scoped>
.main_action {
  width: 100%;
}
.right {
  width: auto;
}
::-webkit-scrollbar {
  display: none;
}
</style>
